export default "__VITE_ASSET__CnDXLPE0__"